import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./leftmenu.css";

const LeftMenu = ({ checked, setChecked, onLogout }) => {
    const [loading, setLoading] = useState(false);

    const handleRunPHP = async (e) => {
        e.preventDefault();
        try {
            setLoading(true);
            const res = await fetch("/php/index.php", {
                method: "POST",
            });
            const data = await res.json();
            console.log("Sync result:", data);
        } catch (err) {
            console.error("Sync error:", err);
        } finally {
            setLoading(false);
              window.location.reload();
        }
    };

    useEffect(() => {
        const btns = [1, 2, 3, 4, 5].map(i => document.querySelector(`.leftmenubtn${i}`));
        btns.forEach((btn, i) => {
            if (!btn) return;
            btn.classList.toggle("active", checked === String(i + 1));
        });
    }, [checked]);

    return (
        <div className="leftmenu">
            <div className="leftmenulogo">
                <button onClick={handleRunPHP} disabled={loading}>
                    {loading
                        ? <div className="loader"></div>
                        : <span><img src="logo.png" alt="logo" /></span>
                    }
                </button>
            </div>
            <div className="leftmenubtns">
                <Link className="leftmenubtn leftmenubtn1" to="/">
                    <span><i className="fas fa-sim-card"></i></span>
                    <h4>Абонентская <br /> плата</h4>
                </Link>
                <Link className="leftmenubtn leftmenubtn2" to="/Zayavki">
                    <span><i className="fas fa-list"></i></span>
                    <h4>Заявки</h4>
                </Link>
                <Link className="leftmenubtn leftmenubtn3" to="/Prixodrasxodgps">
                    <span><i className="fas fa-location-arrow"></i></span>
                    <h4>Приход Расход <br /> GPS Устройств</h4>
                </Link>
                <Link className="leftmenubtn leftmenubtn4" to="/Prixodrasxodmoney">
                    <span><i className="far fa-credit-card"></i></span>
                    <h4>Приход Расход <br /> денежных средств</h4>
                </Link>
                <Link className="leftmenubtn leftmenubtn5" to="/Reports">
                    <span><i className="fas fa-chart-line"></i></span>
                    <h4>Отчет</h4>
                </Link>
            </div>
            <div className="leftmenu-logout">
                <button onClick={onLogout} title="Выйти">
                    <i className="fas fa-sign-out-alt"></i>
                    <span>Выйти</span>
                </button>
            </div>
        </div>
    );
};

export default LeftMenu;
